import { CapacitorHttp } from "@capacitor/core";
import { Vehicle } from "../types/api/vehicle.types";
import { CapacitorHttpAuth, getCookies } from "./auth";
import { baseUrl, requestOptions } from "./api";
import { useQuery } from "react-query";
import { VehiclePart } from "../types/api/vehiclePart.types";
import { useToast } from "../components/ToastContext";
import { ApiError } from "../types/api/api.types";

export const getVehicleById = async (id: string) => {
  try {
    let response = await CapacitorHttpAuth({
      url: `${baseUrl}/driver/vehicles/${id}`,
      method: "GET",
    });

    if (response.status === 200) {
      return response.data as Vehicle;
    } else {
      return {
        error: { status: response.status, message: "Une erreur est survenue" },
      } as ApiError;
    }
  } catch (error) {
    throw error;
  }
};

export const useGetVehicleByIdQuery = (id: string) => {
  return useQuery({
    queryKey: ["getVehicleById"],
    queryFn: async () => {
      let response = await CapacitorHttpAuth({
        url: `${baseUrl}/driver/vehicles/${id}`,
        method: "GET",
      });
      return response.data as Vehicle;
    },
  });
};

export const useGetVehiclePartQuery = ({
  page,
  itemsPerPage,
  type,
  vehicleSide,
}: {
  page?: string;
  itemsPerPage?: string;
  type?: string | string[];
  vehicleSide?: string | [];
}) => {
  return useQuery({
    queryKey: ["getVehiclePart"],
    queryFn: async () => {
      let response = await CapacitorHttpAuth({
        url: `${baseUrl}/driver/vehicleParts/`,
        params: {
          page: page || "1",
          itemsPerPage: itemsPerPage || "30",
          type: type || [],
          vehicleSide: vehicleSide || [],
        },
        method: "GET",
      });
      return response.data as VehiclePart[];
    },
  });
};

export const getVehicleParts = async ({
  page,
  itemsPerPage,
  type,
  vehicleSide,
}: {
  page?: string;
  itemsPerPage?: string;
  type?: string | string[];
  vehicleSide?: string | [];
}) => {
  let response = await CapacitorHttpAuth({
    url: `${baseUrl}/driver/vehicleParts/`,
    params: {
      page: page || "1",
      itemsPerPage: itemsPerPage || "30",
      type: type || [],
      vehicleSide: vehicleSide || [],
    },
    method: "GET",
  });
  return response.data as VehiclePart[];
};
